// extracted by mini-css-extract-plugin
export default {"container":"Benefits_container__Q3sdL","cards-container":"Benefits_cards-container__XrlN2"};